import React from 'react';
import Card from './SignUpV2/Layout/Card';
import Grid from '@rezdy/components/Grid';
import Icon from '@rezdy/components/Icon';
import TextStyle from '@rezdy/components/TextStyle';
import { blue } from '../constants/theme';

const KeyFeature = (props: any) => {
    return (
        <Grid.Container cols="20px 1fr" colGap="8px" placeItems="start">
            <Grid.Cell>
                <div style={{ paddingTop: 3 }}>
                    <Icon name="round-check" size="large" color={blue} />
                </div>
            </Grid.Cell>
            <Grid.Cell alignSelf="start">
                <TextStyle size="small">{props.children}</TextStyle>
            </Grid.Cell>
        </Grid.Container>
    );
};

export const BookingSoftwareMarketingCard = () => (
    <Card photo="/img/signup-img-v3.jpg">
        <Grid.Container rowGap="8px">
            <KeyFeature>
                <TextStyle size="small">Add booking functionality to your website</TextStyle>
            </KeyFeature>
            <KeyFeature>
                <TextStyle size="small">Access Rezdy Channel Manager to grow your distribution network</TextStyle>
            </KeyFeature>
            <KeyFeature>
                <TextStyle size="small">Resell other operators, upsell and earn commissions</TextStyle>
            </KeyFeature>
            <KeyFeature>
                <TextStyle size="small">Guides and tutorials to help you set up</TextStyle>
            </KeyFeature>
            <KeyFeature>
                <TextStyle size="small">Customer support 24/7</TextStyle>
            </KeyFeature>
        </Grid.Container>
    </Card>
);
